import * as React from "react"
import * as _ from "lodash"
import { DietPrescriptionItemRequest, PrescriptionItemGuideline } from "@curefit/gmf-common";
import TemplatedList from "../../TemplatedList"
import ModelFactory from "../../../models/ModelFactory"
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader"
import TextInput from "../../TextInput";
import {ChangeEvent} from "react";
import IStaticDataValue from "../../../../../common/models/IStaticDataValue";
import {AppPlaceholders, MealSlots} from "../../../utils/AppConstants";
import CalorieDistribution from "../../CalorieDistribution";
import IMealSlot from "../../../models/IMealSlot";
import TabsHeader from "../../common/TabsHeader";
import {TabConfig} from "../../../utils/TabManager";
import IFoodCategory from "../../../models/IFoodCategory";
import MealBuilderContainer from "../../../containers/MealBuilderContainer";
import IFetchMealsByCaloriesRequest from "../../../models/IFetchMealsByCaloriesRequest";
import IMealItem from "../../../models/IMealItem";
import IDishCatalogueResponse from "../../../models/maverick/IDishCatalogueResponse";
import {IDietGuideline, IDietMeal, IDietPlan} from "../../../models/LCPlanClientModels";
import {EventNames} from "../../../utils/EventTrackerConstants";

/**
 * Created by aditya on 16/04/18.
 */

let DietPlanEditorThemeHeaderInfos: ICustomHeaderInfo[] = [
    {label: "themes", display: "THEMES"}
];

let DietPlanEditorGuidelineHeaderInfos: ICustomHeaderInfo[] = [
    {label: "guidelines", display: "GUIDELINES (DO's)"}
];

let DietPlanEditorGuidelineHeaderInfosDonts: ICustomHeaderInfo[] = [
    {label: "guidelines", display: "GUIDELINES (DONT's)"}
];


let DietPlanEditorCaloriesHeaderInfos: ICustomHeaderInfo[] = [
    {label: "calories", display: "TOTAL CALORIES / DAY"}
];


export interface PatientDietPlanEditorProps {
    patientId?: number,
    staticMealSlots?: string[],
    staticMealPreferences?: string[],
    updatedDietPlan: {item: IDietPlan},
    updateDietPlan: (updatedDietPlan: {item: IDietPlan}) => void,
    fetchStaticMealData: (input: string) => Promise<any>,
    fetchMealsByCalories: (calorieBreakup: IFetchMealsByCaloriesRequest) => Promise<IMealItem[]>,
    staticFoodGroups: IFoodCategory[],
    fetchStaticFoodGroups: () => Promise<IFoodCategory[]>;
    fetchDishByDishName: (input: string) => Promise<IDishCatalogueResponse[]>;
    fetchMealByMealId: (mealId: string) => Promise<IMealItem>;
    previewMeal: (meal: IMealItem) => Promise<IMealItem>;
    createMeal: (meal: IMealItem) => Promise<IMealItem>;
    fetchStaticDietGuidelines: (input: string, category: string) => Promise<any[]>;
    suggestions: {[key: string]: any}
}

export interface PatientDietPlanEditorState {
    caloriePerDay: number,
    calorieDistribution: boolean,
    allTabs: TabConfig[],
    activeTab: TabConfig,
    activeTabIdx: number
}

class PatientDietPlanEditor extends React.Component<PatientDietPlanEditorProps, PatientDietPlanEditorState> {
    private mealBuilderCont: any;

    constructor(props: PatientDietPlanEditorProps) {
        super(props);
        let caloriePerDay = this.calculateTotalCaloriesPerDay();
        let allTabs = !_.isEmpty(props.updatedDietPlan.item.meals) ? this.generateTabList() : null;
        let activeTab = !_.isEmpty(allTabs) ? allTabs[0] : null;
        this.state = {
            caloriePerDay,
            calorieDistribution: false,
            allTabs,
            activeTab,
            activeTabIdx: 0
        }
    }

    componentWillMount() {
        if (_.isEmpty(this.props.staticFoodGroups)) {
            this.props.fetchStaticFoodGroups();
        }
    }

    onDietGuidelineDoRemove = (index: number) => {
        let currUpdatedDietPlan = { ...this.props.updatedDietPlan };
        let doGuidelines = this.props.updatedDietPlan.item.guidelines.filter(item => item.type === "DO");
        doGuidelines.splice(index, 1);
        currUpdatedDietPlan.item.guidelines = doGuidelines.concat(this.props.updatedDietPlan.item.guidelines.filter(item => item.type === "DONT"));
        this.props.updateDietPlan(currUpdatedDietPlan);
    }

    onDietGuidelineDoChange = (updatedTheme: {item: IStaticDataValue}, index: number) => {
        let currUpdatedDietPlan = { ...this.props.updatedDietPlan };
        let dietGuidelines = !_.isEmpty(this.props.updatedDietPlan.item.guidelines) ? this.props.updatedDietPlan.item.guidelines.filter(item => item.type === "DO") : [];
        dietGuidelines[index] = { guideline: updatedTheme.item.displayValue, type: "DO" };
        let dontGuidelines = !_.isEmpty(this.props.updatedDietPlan.item.guidelines) ? this.props.updatedDietPlan.item.guidelines.filter(item => item.type === "DONT") : [];
        currUpdatedDietPlan.item.guidelines = dietGuidelines.concat(dontGuidelines);
        this.props.updateDietPlan(currUpdatedDietPlan);
    }

    onDietGuidelineDontRemove = (index: number) => {
        let currUpdatedDietPlan = { ...this.props.updatedDietPlan };
        let doGuidelines = this.props.updatedDietPlan.item.guidelines.filter(item => item.type === "DONT");
        doGuidelines.splice(index, 1);
        currUpdatedDietPlan.item.guidelines = doGuidelines.concat(this.props.updatedDietPlan.item.guidelines.filter(item => item.type === "DO"));
        this.props.updateDietPlan(currUpdatedDietPlan);
    }

    onDietGuidelineDontChange = (updatedTheme: {item: IStaticDataValue}, index: number) => {
        let currUpdatedDietPlan = { ...this.props.updatedDietPlan };
        let dietGuidelines = !_.isEmpty(this.props.updatedDietPlan.item.guidelines) ? this.props.updatedDietPlan.item.guidelines.filter(item => item.type === "DONT") : [];
        dietGuidelines[index] = { guideline: updatedTheme.item.displayValue, type: "DONT" };
        let doGuidelines = !_.isEmpty(this.props.updatedDietPlan.item.guidelines) ? this.props.updatedDietPlan.item.guidelines.filter(item => item.type === "DO") : [];
        currUpdatedDietPlan.item.guidelines = dietGuidelines.concat(doGuidelines);
        this.props.updateDietPlan(currUpdatedDietPlan);
    }

    onDietThemeRemove = (index: number) => {
        let currUpdatedDietPlan = { ...this.props.updatedDietPlan };
        let dietThemes = this.props.updatedDietPlan.item.themes;
        dietThemes.splice(index, 1);
        currUpdatedDietPlan.item.themes = dietThemes;
        this.props.updateDietPlan(currUpdatedDietPlan);
    }

    onDietThemeChange = (updatedTheme: {item: string}, index: number) => {
        let currUpdatedDietPlan = { ...this.props.updatedDietPlan };
        let dietThemes = !_.isEmpty(this.props.updatedDietPlan.item) && !_.isEmpty(this.props.updatedDietPlan.item.themes) ? this.props.updatedDietPlan.item.themes : [];
        dietThemes[index] = updatedTheme.item;
        currUpdatedDietPlan.item.themes = dietThemes;
        this.props.updateDietPlan(currUpdatedDietPlan);
    }

    onTotalCaloriesChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (!isNaN(parseInt(event.target.value)) || event.target.value === "") {
            let calories = event.target.value !== "" ? parseInt(event.target.value) : null;
            this.setState({
                caloriePerDay: calories
            })
        }
    }

    calculateTotalCaloriesPerDay = (): number => {
        if (!_.isEmpty(this.props.updatedDietPlan.item) && !_.isEmpty(this.props.updatedDietPlan.item.meals)) {
            let calories = 0;
            _.map(this.props.updatedDietPlan.item.meals, (mealItem) => {
                calories += parseInt(mealItem.details.calories.toString());
            })
            return calories;
        } else {
            return null;
        }
    }

    generateGuidelinesList = (type: string) => {
        let finalList: {item: IStaticDataValue}[] = [];
        if (this.props.updatedDietPlan && this.props.updatedDietPlan.item && this.props.updatedDietPlan.item.guidelines) {
            finalList = this.props.updatedDietPlan.item.guidelines.filter((item: IDietGuideline) => item.type === type).map((item: IDietGuideline) => ({
                item: {displayValue: item.guideline, internalValue: item.guideline}
            }))
        }
        return finalList;
    }
    generateThemesList = () => {
        return _.map(this.props.updatedDietPlan.item.themes || [], (theme: string) => ({ item: theme }))
    }
    generateTabList = () => {
        let headers: TabConfig[] = [];
        let currentMealSlots = this.props.updatedDietPlan.item.meals;
        _.map(MealSlots, (name, key) => {
            let meal = currentMealSlots.filter(item => item.mealSlot === key);
            if (meal.length) {
                let tabConfig: TabConfig = ModelFactory.createNewTabConfig();
                let formattedHeader = `${name.toUpperCase()}`
                tabConfig.id = key;
                tabConfig.tabName = key;
                tabConfig.display = formattedHeader;
                headers.push(tabConfig);
            }
        })
        return headers;
    }
    toggleCalorieDistribution = () => {
        if (!_.isNull(this.state.caloriePerDay)) {
            this.setState({
                calorieDistribution: !this.state.calorieDistribution
            })
        }
    }
    updateCalorieDistribution = (calorieDistribution: any) => {
        let updatedDietPlan = this.props.updatedDietPlan;
        let currentMeals = !_.isEmpty(updatedDietPlan.item) && !_.isEmpty(updatedDietPlan.item.meals) ? updatedDietPlan.item.meals : [];
        let meals: IMealSlot[] = [];
        _.map(calorieDistribution, (value: number, key: string) => {
            let meal = ModelFactory.createNewMealSlot();
            meal.mealSlot = key;
            if (!_.isEmpty(currentMeals) && currentMeals.map(item => item.mealSlot).indexOf(key) !== -1) {
                let index = currentMeals.map(item => item.mealSlot).indexOf(key);
                meal = currentMeals[index];
            }
            meal.details.calories = value || 0; // Decide on the default value as 0 or null
            // meal.details.calorieBreakup = [];
            meals.push(meal);
        })
        updatedDietPlan.item.meals = meals;
        let tabList = this.generateTabList();
        this.setState({
            calorieDistribution: false,
            allTabs: tabList,
            activeTab: tabList[0],
            activeTabIdx: 0
        }, () => {
            this.props.updateDietPlan(updatedDietPlan);
        })
    }

    getFormattedCalorieDistribution = () => {
        let calorieDistribution = {} as any;
        if (!_.isEmpty(this.props.updatedDietPlan.item) && !_.isEmpty(this.props.updatedDietPlan.item.meals)) {
            _.map(this.props.updatedDietPlan.item.meals, (item, index) => {
                calorieDistribution[item.mealSlot] = item.details.calories;
            })
        }
        return calorieDistribution;
    }
    updateActiveTab= (activeTab: TabConfig, activeTabIdx: number) => {
        this.updateMealSlots(this.mealBuilderCont.getSaveObject());
        this.setState({activeTab: activeTab, activeTabIdx: activeTabIdx})
    }
    getMealSlotForCurrentTab = () => {
        let mealSlot;
        let activeTab = this.state.activeTab;
        if (!_.isEmpty(activeTab)) {
            mealSlot = this.props.updatedDietPlan.item.meals.filter(item => item.mealSlot === activeTab.id)
        }
        return mealSlot[0];
    }

    updateMealSlots = (updatedMealSlot: IDietMeal) => {
        let dietPlan = { ...this.props.updatedDietPlan.item };
        let requiredSlot = dietPlan.meals.filter(item => item.mealSlot === updatedMealSlot.mealSlot);
        if (requiredSlot.length) {
            let index = dietPlan.meals.map(item => item.mealSlot).indexOf(updatedMealSlot.mealSlot);
            dietPlan.meals[index] = updatedMealSlot;
        } else {
            dietPlan.meals.push(updatedMealSlot);
        }
        this.props.updateDietPlan({ item: dietPlan });
    }

    render() {
        let fetchStaticMealData = this.props.fetchStaticMealData;
        let fetchStaticGuidelines = this.props.fetchStaticDietGuidelines;
        let dos = this.generateGuidelinesList("DO");
        let donts = this.generateGuidelinesList("DONT");
        // let guidelinesList = !_.isEmpty(this.props.updatedDietPlan) && !_.isEmpty(this.props.updatedDietPlan.item) ? this.generateGuidelinesList(this.props.updatedDietPlan.item.guidelines) : null;
        // let themeList = !_.isEmpty(this.props.updatedDietPlan) && !_.isEmpty(this.props.updatedDietPlan.item) && !_.isEmpty(this.props.updatedDietPlan.item.prescriptionDetail) ? this.props.updatedDietPlan.item.prescriptionDetail.overallDietThemes : null;
        return (
            <div className="patient-diet-plan-editor">
                <CustomHeader headerInfos={DietPlanEditorThemeHeaderInfos} rootCls={"patient-diet-plan-themes"}/>
                <div className={"patient-diet-plan-themes-container"}>
                    <TemplatedList templateName={"dietTheme"} commonProps={{fetchStaticMealData}}
                                   defaultItem={{item: ""}}
                                   listItems={this.generateThemesList()}
                                   onItemRemove={this.onDietThemeRemove}
                                   onItemChange={this.onDietThemeChange}/>
                </div>

                <div className={"do-guidelines"}>
                    <CustomHeader headerInfos={DietPlanEditorGuidelineHeaderInfos} rootCls={"patient-diet-plan-guidelines"}/>
                    <div className={"patient-diet-plan-guidelines-container"}>
                        <TemplatedList templateName={"dietGuidelines"} commonProps={{fetchStaticMealData, fetchStaticGuidelines, guidelineType: "DO"}}
                                   defaultItem={{item: ModelFactory.createNewStaticItem()}}
                                   listItems={dos}
                                   onItemRemove={this.onDietGuidelineDoRemove}
                                   onItemChange={this.onDietGuidelineDoChange}/>
                    </div>
                </div>

                <div className={"dont-guidelines"}>
                    <CustomHeader headerInfos={DietPlanEditorGuidelineHeaderInfosDonts} rootCls={"patient-diet-plan-guidelines"}/>
                    <div className={"patient-diet-plan-guidelines-container"}>
                        <TemplatedList templateName={"dietGuidelines"} commonProps={{fetchStaticMealData, fetchStaticGuidelines, guidelineType: "DONT"}}
                                       defaultItem={{item: ModelFactory.createNewStaticItem()}}
                                       listItems={donts}
                                       onItemRemove={this.onDietGuidelineDontRemove}
                                       onItemChange={this.onDietGuidelineDontChange}/>
                    </div>
                </div>

                {/*<CustomHeader headerInfos={DietPlanEditorCaloriesHeaderInfos} rootCls={"patient-diet-plan-calories"}/>*/}
                <div className="total-calories-per-day">
                    {/*<TextInput name={"diet-plan-calories"} onChange={this.onTotalCaloriesChange}*/}
                               {/*value={this.state.caloriePerDay} placeholder={AppPlaceholders.DIET_PLAN_EDITVIEW_CALORIES}*/}
                               {/*disabled={this.state.calorieDistribution} />*/}
                    {/*<span className={`distribute-label ${_.isNull(this.state.caloriePerDay) ? "disabled" : ""}`} onClick={this.toggleCalorieDistribution}>Distribute</span>*/}
                    {
                        // this.state.calorieDistribution &&
                    }
                    <CalorieDistribution calorieDistribution={this.getFormattedCalorieDistribution()} totalCaloriesPerDay={this.state.caloriePerDay} updateCalorieDistribution={this.updateCalorieDistribution}/>
                </div>

                {
                    !_.isEmpty(this.state.allTabs) && !_.isEmpty(this.state.allTabs) &&
                    <div className={"meal-builder-container"}>
                        <TabsHeader tabs={this.state.allTabs} activeTab={this.state.activeTab} updateActiveTab={this.updateActiveTab}  trackerEvents={{ flow: EventNames.Consultation }} />
                        <MealBuilderContainer ref={(dom: any) => this.mealBuilderCont = dom}
                                              updateMealSlots={this.updateMealSlots} mealSlot={this.getMealSlotForCurrentTab()}
                                              staticFoodGroups={this.props.staticFoodGroups}
                                              fetchMealByCalories={this.props.fetchMealsByCalories}
                                              previewMeal={this.props.previewMeal}
                                              fetchDishByDishName={this.props.fetchDishByDishName}
                                              fetchMealByMealId={this.props.fetchMealByMealId}
                                              createMeal={this.props.createMeal}
                                              suggestions={this.props.suggestions} />
                    </div>
                }

                {/*<MealOptionsEditViewCont patientId={this.props.patientId} patientMealOptions={currentMealSlot} staticMealSlots={this.props.staticMealSlots}
                                         staticMealPreferences={this.props.staticMealPreferences} displayMode={EditViewDisplayMode.EDIT}/>*/}
            </div>
        );
    }
}

export default PatientDietPlanEditor